<fcp-folder-card
    *ngIf="!isError && cardType === getCardType('FOLDER')"
    [properties]="cardProperties"
    (outputActions)="callAction($event)"
    (outputClick)="onClick($event)"
>
    <span fcpDragHandle>
        <ng-content select="fcp-icon[fcpDragHandle]"></ng-content>
    </span>
</fcp-folder-card>

<fcp-article-card *ngIf="!isError && cardType === getCardType('ARTICLE')" [properties]="cardProperties">
</fcp-article-card>

<fcp-tile-card
    *ngIf="!isError && cardType === getCardType('TILE')"
    [properties]="cardProperties"
    (click)="callAction($event)"
>
    <div fcpTileCardHoverBadge>
        <ng-content select="[fcpTileCardHoverBadge]"></ng-content>
    </div>
    <div fcpTileCardBadge>
        <ng-content select="[fcpTileCardBadge]"></ng-content>
    </div>
</fcp-tile-card>

<fcp-store-card *ngIf="!isError && cardType === getCardType('STORE')" [properties]="cardProperties">
    <div fcpStoreCardSelector>
        <ng-content select="[fcpStoreCardSelector]"></ng-content>
    </div>
    <div fcpStoreCardTitle>
        <ng-content select="[fcpStoreCardTitle]"></ng-content>
    </div>
    <div fcpStoreCardContent class="card-placeholder-content">
        <ng-content select="[fcpStoreCardContent]"></ng-content>
    </div>
    <div fcpStoreCardFooter>
        <ng-content select="[fcpStoreCardFooter]" class="card-placeholder-footer-icon"></ng-content>
    </div>
</fcp-store-card>

<div #cardLabel>
    <ng-content select="[fcpCardLabel]"></ng-content>
</div>
